import { Star, ExternalLink } from "lucide-react";

const GOOGLE_URL = "https://www.google.com/maps/search/?api=1&query=Raffiel+Nias+Sorake";
const TRIPADVISOR_URL = "https://www.tripadvisor.com/Hotel_Review-g13957042-d8599472-Reviews-Raffiel_Nias-Botohilitano_Nias_Island_North_Sumatra_Sumatra.html";

const REVIEWS = [
  {
    quote:
      "Great place to stay, the property itself is just right in front of the ocean. Raffiel and the crew are the best at their job. Room is always clean, foods are amazing and the people are super friendly.",
    name: "Ben",
    meta: "Australia · stayed 2 weeks",
    source: "TripAdvisor",
  },
  {
    quote:
      "The family will take care of you, rooms are tidy and clean, staff service is top. The restaurant serves more delicious food than other places — been to Nias a few times and finally found the right one.",
    name: "Seangood",
    meta: "Perth, Australia",
    source: "TripAdvisor",
  },
  {
    quote:
      "Great hospitality, great location, food was good — usually BBQ chicken or fresh fish caught that day. Lovely local family with strong links to surf history in the area. It's the perfect surf retreat.",
    name: "Robert G",
    meta: "Traveled with friends",
    source: "TripAdvisor",
  },
];

const Stars = () => (
  <div className="flex gap-0.5 justify-center">
    {[...Array(5)].map((_, i) => (
      <Star key={i} size={16} className="fill-terracotta text-terracotta" />
    ))}
  </div>
);

const Testimonial = () => (
  <section id="reviews" className="py-20 bg-sand-100 border-y border-sand-200" data-testid="testimonial-section">
    <div className="max-w-4xl mx-auto px-6 text-center">
      <span className="text-xs font-mono-clean text-terracotta uppercase tracking-wider font-semibold">
        Guest Experience
      </span>
      <div className="mt-4 inline-flex flex-col items-center gap-2">
        <Stars />
        <p className="font-display text-lg font-bold text-ocean-900" data-testid="google-rating-badge">
          4.9 on Google · 39 reviews
        </p>
      </div>
      <blockquote className="font-display text-2xl sm:text-3xl text-ocean-900 font-medium leading-relaxed my-8">
        &ldquo;Great value for what you get. Comfortable rooms, good aircon, and
        reliable WiFi (which is rare here).&rdquo;
      </blockquote>
      <div className="inline-flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-ocean-700 text-white flex items-center justify-center font-display font-bold">
          DK
        </div>
        <div className="text-left">
          <p className="text-sm font-bold text-ocean-900">Daniel K.</p>
          <p className="text-xs text-fog">Germany</p>
        </div>
      </div>
    </div>

    <div className="max-w-7xl mx-auto px-6 mt-14">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {REVIEWS.map((r, i) => (
          <figure
            key={r.name}
            data-testid={`review-card-${i}`}
            className="bg-sand-50 p-6 rounded-2xl border border-sand-200 flex flex-col justify-between shadow-sm hover:shadow-md transition-shadow"
          >
            <div>
              <Stars />
              <blockquote className="text-sm text-ink leading-relaxed mt-4 font-display">
                &ldquo;{r.quote}&rdquo;
              </blockquote>
            </div>
            <figcaption className="mt-5 pt-4 border-t border-sand-200 flex items-center justify-between">
              <div>
                <p className="text-sm font-bold text-ocean-900">{r.name}</p>
                <p className="text-xs text-fog">{r.meta}</p>
              </div>
              <span className="text-[10px] font-mono-clean uppercase tracking-wider text-fog">
                {r.source}
              </span>
            </figcaption>
          </figure>
        ))}
      </div>
      <div className="text-center mt-8 flex flex-col sm:flex-row items-center justify-center gap-6">
        <a
          href={GOOGLE_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="reviews-google-link"
          className="inline-flex items-center gap-1.5 text-sm font-semibold text-ocean-700 hover:underline"
        >
          Read all reviews on Google <ExternalLink size={14} />
        </a>
        <a
          href={TRIPADVISOR_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="reviews-tripadvisor-link"
          className="inline-flex items-center gap-1.5 text-sm font-semibold text-ocean-700 hover:underline"
        >
          Reviews on TripAdvisor <ExternalLink size={14} />
        </a>
      </div>
    </div>
  </section>
);

export default Testimonial;
